import React from 'react';
import { CTAButton } from '../CTAButton';
import { IMAGES } from '../../data/links';
import { fourSteps } from '../../data/lists';
const collected = ['Charts', 'Books', 'Videos', 'Notes', 'PDFs', 'Courses'];
export function About() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-57" data-mp="12q3x8ezs80vm">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:items-start" data-id="element-58" data-mp="yp1zy3pfdywa">
        <div className="md:sticky md:top-8" data-id="element-59" data-mp="b0sej2w4jd5o">
          <img src={IMAGES.elly} alt="Elly Delgado, reflexology expert" className="w-full rounded-3xl object-cover shadow-[0_20px_50px_-24px_rgba(10,51,40,0.5)]" data-id="element-60" data-mp="axcy9wqpry2o" />
          <div className="mt-4 text-center md:text-left" data-id="element-61" data-mp="f1cfkhjtj0x3">
            <h2 className="font-serif text-3xl font-bold text-forest" data-id="element-62" data-mp="ezrm6v98po0t">Meet Elly Delgado</h2>
            <p className="mt-1 text-sm font-bold uppercase tracking-wider text-cta" data-id="element-63" data-mp="3nfl0d3g3mnep">
              Reflexology expert & creator of the 21-Day Practice Method™
            </p>
          </div>
        </div>

        <div className="space-y-4 text-lg leading-relaxed text-ink/90" data-id="element-64" data-mp="338p6hf81qj01">
          <p data-id="element-65" data-mp="387jrmnthkjnb">For years, I've watched people who are learning reflexology collect more and more information.</p>
          <ul className="flex flex-wrap gap-2" data-id="element-66" data-mp="3d0csh0lu37u4">
            {collected.map(c => <li key={c} className="rounded-full bg-paper px-3 py-1 text-sm font-semibold text-forest" data-id="element-67" data-mp="3hyeenuek3n9t">{c}</li>)}
          </ul>
          <p data-id="element-68" data-mp="2kcgyw4rk9w1k">And yet, when it was time to actually practice, many of them still asked themselves:</p>
          <p className="font-serif text-xl font-semibold italic text-forest" data-id="element-69" data-mp="2pbjtswdtulvt">
            “Where do I start?” “What should I practice today?” “Am I actually making progress?”
          </p>
          <p data-id="element-70" data-mp="2z8y8ork3r2m0">
            And I completely understand why. When you're learning a practical skill like reflexology, having information is only
            part of the journey. <strong data-id="element-71" data-mp="egmlwdslizak">You also need a way to use it.</strong>
          </p>
          <p data-id="element-72" data-mp="2akamakndotmh">
            That's what inspired me to create REFLEXOLOGY 21-DAY PRACTICE METHOD™. I didn't want to create another long course. I
            didn't want to give you another giant ebook filled with information. And I definitely didn't want to give you something
            you'd open once and forget about.
          </p>
          <p data-id="element-73" data-mp="2fkosry9bzvie">I wanted to create something you could open every day. Something that would tell you:</p>
          <ul className="space-y-1 border-l-4 border-cta pl-4 font-serif text-lg italic text-forest" data-id="element-74" data-mp="1ruukltzyiv4h">
            <li data-id="element-75" data-mp="1mw9gvklhxtba">“This is what we're focusing on today.”</li>
            <li data-id="element-76" data-mp="20m4nibwvc3lu">“This is what you're going to practice.”</li>
            <li data-id="element-77" data-mp="20no5c6y6ampq">“This is what you're going to record.”</li>
            <li data-id="element-78" data-mp="1vvejp343c8t9">“And this is what you're going to review.”</li>
          </ul>
          <p data-id="element-79" data-mp="185tx8a8qatf8">So I built the method around a simple structure:</p>
          <p className="font-extrabold uppercase tracking-wider text-forest" data-id="element-80" data-mp="183zaqrht6t91">
            {fourSteps.map(s => s.label).join(' → ')}
          </p>
          <p data-id="element-81" data-mp="u0a1wvh45iaq">For approximately 15 minutes a day. For 21 days. One step at a time.</p>
          <p data-id="element-82" data-mp="yr09mfd0hx8l">
            My goal with this method isn't to overwhelm you with more information. It's to help you take what you're already
            learning about reflexology and turn it into a more consistent, organized practice.
          </p>
          <p data-id="element-83" data-mp="p1yq4f79cxpv">
            Because I believe you don't need another reason to postpone practicing.{' '}
            <strong data-id="element-84" data-mp="1crt3qyzeiqb6">You need a clear next step.</strong> And that's what I wanted to give you.
          </p>
          <p className="font-serif text-2xl font-bold italic text-forest" data-id="element-85" data-mp="1hpcqyoe2udf9">I'll see you on Day 1.</p>
          <p className="text-base text-muted" data-id="element-86" data-mp="12uy6skis0xz0">
            — Elly Delgado · Reflexology Expert · Creator of REFLEXOLOGY 21-DAY PRACTICE METHOD™
          </p>
          <div className="pt-4" data-id="element-87" data-mp="3nit6y0ysxnw2">
            <CTAButton label="Yes! I'll see you on Day 1, Elly" note="Only $27 · Instant digital access" data-id="element-88" data-mp="3nhrnp97mtv39" />
          </div>
        </div>
      </div>
    </section>;
}